"use strict";

angular.module('app.factories.user', []).

// -------------------------------------------//
//               f_User is for UserVars
// -------------------------------------------//

factory('f_User', ['conf_userlevel',
    function (conf_userlevel) {

        var User = {};
        var UserType = '';
        var UserTypeDisplay  = '';
        var obj = {
            setUserLevel: function (l) {
                var o = {UserLevel: l};
                User = angular.extend(User, o);
                if(l > 0 && l <= 10){
                    UserTypeDisplay = 'USER_User';
                }else{
                    UserTypeDisplay = 'USER_Expert'
                }
                for (var key in conf_userlevel) {
                    if (conf_userlevel.hasOwnProperty(key)) {
                        if (conf_userlevel[key] == l) {
                            UserType = key;
                            break;
                        }
                    }
                }
                return this;
            },
            getUserLevel: function () {
                return User.UserLevel ? User.UserLevel : 0;
            },
            getUser: function () {
                return User;
            },
            getUserType: function () {
                return UserTypeDisplay;
            },
            is: function (type) {
                if (User.UserLevel && conf_userlevel.hasOwnProperty(type)) {
                    if (User.UserLevel >= conf_userlevel[type]) return true;
                }
                return false;
            }
        };

        return obj;

    }
]);
